import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { trackCta } from '../analytics';
import PlatformMarquee from './PlatformMarquee';
import ScrollCue from './ScrollCue';
import { StaggerReveal, StaggerItem } from './ScrollReveal';
import BookDemoButton from './BookDemoButton';
import './Hero.css';

const Hero = () => {
  const reduceMotion = useReducedMotion();
  const appBaseUrl = process.env.REACT_APP_APP_URL || 'https://app.pycrust.io';
  const loginUrl = `${appBaseUrl}/login`;
  const demoVideoId = process.env.REACT_APP_DEMO_VIDEO_ID;

  return (
    <>
      <section id="home" className="hero hero--dynamic hero--centered" aria-labelledby="hero-heading">
        <div className="hero-mesh" aria-hidden>
          <span className="hero-blob hero-blob--1" />
          <span className="hero-blob hero-blob--2" />
          <span className="hero-blob hero-blob--3" />
        </div>

        <div className="hero-dynamic-inner hero-dynamic-inner--centered">
          <StaggerReveal className="hero-dynamic-copy hero-dynamic-copy--centered">
            <StaggerItem>
              <h1 id="hero-heading" className="hero-dynamic-title">
                Your social agency{' '}
                <span className="hero-title-emphasis">operating system.</span>
              </h1>
            </StaggerItem>

            <StaggerItem>
              <p className="hero-description hero-dynamic-lead">
                Plan, review, and post for every client in one place.
              </p>
            </StaggerItem>

            <StaggerItem>
              <div className="hero-actions hero-actions--centered cta-actions-row cta-actions-row--center">
                <motion.button
                  type="button"
                  className="btn btn-primary hero-dynamic-cta"
                  whileHover={reduceMotion ? undefined : { scale: 1.03, y: -2 }}
                  whileTap={reduceMotion ? undefined : { scale: 0.98 }}
                  onClick={() => {
                    trackCta('get_started', 'hero');
                    window.open(loginUrl, '_blank');
                  }}
                >
                  Get started
                  <ArrowRight className="ui-icon-2xl" aria-hidden />
                </motion.button>
                <BookDemoButton placement="hero" className="hero-dynamic-cta" />
              </div>
            </StaggerItem>

            <StaggerItem>
              <PlatformMarquee />
            </StaggerItem>
          </StaggerReveal>
        </div>

        <ScrollCue sectionId="home" targetId="workflow" />
      </section>

      {demoVideoId && (
        <section className="hero-demo">
          <div className="hero-demo-inner">
            <h2 className="hero-demo-title">See it in action</h2>
            <div className="hero-demo-video-wrapper">
              <iframe
                title="Pycrust demo"
                src={`https://www.youtube.com/embed/${demoVideoId}?rel=0`}
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                className="hero-demo-video"
              />
            </div>
          </div>
        </section>
      )}
    </>
  );
};

export default Hero;
